import React, { useState } from 'react';
import Navbar from '../Components/NavBarV2';
import Footer from '../Components/footer';
import MiecolesNeg1 from '../images/miercoles_negocios_10_12.jpg';
import MiecolesNeg2 from '../images/miercoles_negocios_27_11.jpg';
import Kamay1 from '../images/kamay1.jpg';
import Kamay2 from '../images/kamay2.jpg';
import './eventsProximo.css';
import WhatsAppButton from '../Components/whatsappbutton';

const Events = () => {
    return (
        <div>
            <Navbar />
            <WhatsAppButton />

            <div className='contenedor-events'>
                <div className='direfrentes_eventos'>
                    <img src={MiecolesNeg1} alt="MiecolesNeg1" class="MiecolesNeg1" />
                    <img src={MiecolesNeg2} alt="MiecolesNeg2" class="MiecolesNeg2" />
                    <img src={Kamay1} alt="Kamay1" class="Kamay1" />
                    <img src={Kamay2} alt="Kamay2" class="Kamay2" />
                </div>
            </div>
        </div>

    );

};


export default Events;